import { 
	HIGHLIGHT_GEOJSON_COUNTRY_LAYER,
	SHOW_COUNTRY_NAME_TOOLTIP
} from '../constants/map-action-types';
// import _ from 'lodash';

const initialState = {
	highlightedCountry: null,
	countryNameTooltip:''
};

export default function mapReducers(state = initialState, action) {
	if (action.type === HIGHLIGHT_GEOJSON_COUNTRY_LAYER) {	
		const highlightedCountry = action.payload;
		return Object.assign({}, state, {			
			highlightedCountry
		});
	}
	if (action.type === SHOW_COUNTRY_NAME_TOOLTIP){
		return Object.assign({}, state, {			
			countryNameTooltip:action.payload
		});
	}
	
	return state;
}
